import { useParams } from 'react-router';

import { DocList } from '../../docs/components/DocList';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { ManagerMenu } from '../../manager/managermenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';

const ManagerDocFilterPage = () => {
  const { id } = useParams<{ id: string }>();
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.manager ? (
        <AppWrapper
          appType={APP_TYPE.MANAGER}
          menu={<ManagerMenu />}
          resource='RelatedApps'
          action='allow_manager_all'
        >
          <DocList docId={parseInt(id!, 10)} />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default ManagerDocFilterPage;
